import { render, staticRenderFns } from "./ExpandedTopPages.vue?vue&type=template&id=767ca81c&scoped=true&"
import script from "./ExpandedTopPages.vue?vue&type=script&lang=js&"
export * from "./ExpandedTopPages.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedTopPages.vue?vue&type=style&index=0&id=767ca81c&prod&lang=scss&"
import style1 from "./ExpandedTopPages.vue?vue&type=style&index=1&id=767ca81c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ca81c",
  null
  
)

export default component.exports